import { MdEdit } from 'react-icons/md';
import upperFirst from 'lodash/upperFirst';
import { Button } from '@/components/ui/button';
import { parseInlineMarkdown } from '@/util/parseInlineMarkdown';

interface ResponseButtonProps {
  label: string;
  selected: boolean;
  multiselect?: boolean;
  onChange: (value: boolean) => void;
  freeform?: boolean;
  showEdit?: boolean;
  onEdit?: () => void;
  justifyStart?: boolean;
  comment?: string;
}

const ResponseCheckbox = ({ selected }: { selected: boolean }) => {
  return (
    <div
      className={`flex size-4.5 shrink-0 items-center justify-center rounded border transition-colors group-hover:border-indigo-900 ${
        selected ? 'border-indigo-900 bg-transparent p-0.75' : 'border-gray-500'
      }`}
      aria-hidden
    >
      {selected && <div className="size-3 shrink-0 rounded-xs bg-indigo-900" />}
    </div>
  );
};

export const ResponseButton = ({
  label,
  selected,
  onChange,
  multiselect,
  freeform,
  showEdit,
  onEdit,
  justifyStart = false,
  comment,
  ...props
}: ResponseButtonProps) => {
  return (
    <Button
      variant="response"
      size="md"
      data-selected={selected}
      onClick={() => onChange(!selected)}
      className="mb-1 w-full"
      {...props}
    >
      <div className="flex w-full flex-row items-start justify-between gap-3">
        <div className="flex min-w-0 flex-1 flex-col gap-0.5">
          <div
            className={`flex flex-row items-center gap-3 ${
              justifyStart ? 'items-start' : ''
            }`}
          >
            {multiselect && <ResponseCheckbox selected={selected} />}
            <span>{parseInlineMarkdown(upperFirst(label))}</span>
          </div>
          {comment && (
            <span
              className={`text-sm font-extralight ${
                multiselect ? 'pl-7.5' : ''
              }`}
            >
              {parseInlineMarkdown(comment)}
            </span>
          )}
        </div>
        {((freeform && selected) || showEdit) && (
          <MdEdit
            onClick={(e) => {
              e.stopPropagation();
              onEdit?.();
              onChange(!selected);
            }}
            className="size-5"
          />
        )}
      </div>
    </Button>
  );
};
